module.exports = "/_next/static/images/bank-bri-icon-c60cb244d39d15f15038062ed06def36.svg";